import './PlaceholderLoader.css';

const PlaceholderLoader = () => {
  return (
    <div className="hvnly--builder---api_property__singleProperty__builder__tab_content_panel">
      <div className="hvnly--builder---api_property__singleProperty__builder__container hvnly--builder---api_property__singleProperty__builder__container--loading">
        <div className="hvnly--builder---api_property__singleProperty__builder__main">
          <div className="hvnly--builder---api_property__singleProperty__builder__preview_section">
            <div className="hvnly--builder---api_property__singleProperty__builder__single_item">
              
              {/* Gallery Section Placeholder */}
              <div className="hvnly--builder---api_property__singleProperty__builder__gallery placeholder">
                <div className="hvnly--builder---api_property__singleProperty__builder__gallery_thumbnail placeholder-shimmer"></div>
                <div className="hvnly--builder---api_property__singleProperty__builder__gallery_center placeholder-shimmer">
                  <div className="hvnly--builder---api_property__singleProperty__builder__editable_area placeholder">
                    <span className="hvnly--builder---api_property__singleProperty__builder__area_label placeholder-shimmer"></span>
                    <div className="hvnly--builder---api_property__singleProperty__builder__add_element_btn placeholder-shimmer"></div>
                    <div className="hvnly--builder---api_property__singleProperty__builder__gallery_content placeholder-shimmer"></div>
                  </div>
                </div>
              </div>
              
              <div className="hvnly--builder---api_property__singleProperty__builder__body">
                
                {/* Title Area Placeholder */}
                <div className="hvnly--builder---api_property__singleProperty__builder__editable_area placeholder">
                  <span className="hvnly--builder---api_property__singleProperty__builder__area_label placeholder-shimmer"></span>
                  <div className="hvnly--builder---api_property__singleProperty__builder__title_area placeholder">
                    <div className="hvnly--builder---api_property__singleProperty__builder__title_block_area_left">
                      <div className="hvnly--builder---api_property__singleProperty__builder__add_element_btn placeholder-shimmer"></div>
                      <div className="hvnly--builder---api_property__singleProperty__builder__field_placeholder placeholder-shimmer"></div>
                      <div className="hvnly--builder---api_property__singleProperty__builder__field_placeholder placeholder-shimmer"></div>
                    </div>
                    <div className="hvnly--builder---api_property__singleProperty__builder__title_block_area_right">
                      <div className="hvnly--builder---api_property__singleProperty__builder__add_element_btn placeholder-shimmer"></div>
                    </div>
                  </div>
                </div>
                
                {/* Details Overview Placeholder */}
                <div className="hvnly--builder---api_property__singleProperty__builder__editable_area placeholder">
                  <span className="hvnly--builder---api_property__singleProperty__builder__area_label placeholder-shimmer"></span>
                  <div className="hvnly--builder---api_property__singleProperty__builder__add_element_btn placeholder-shimmer"></div>
                  <div className="hvnly--builder---api_property__singleProperty__builder__features placeholder">
                    <h2 className="placeholder-shimmer"></h2>
                    <div className="hvnly--builder---api_property__singleProperty__builder__details placeholder">
                      {[...Array(8)].map((_, index) => (
                        <div key={index} className="hvnly--builder---api_property__singleProperty__builder__detail_item placeholder-shimmer"></div>
                      ))}
                    </div>
                  </div>
                </div>
                
                {/* Features Section Placeholder */}
                <div className="hvnly--builder---api_property__singleProperty__builder__editable_area placeholder">
                  <span className="hvnly--builder---api_property__singleProperty__builder__area_label placeholder-shimmer"></span>
                  <div className="hvnly--builder---api_property__singleProperty__builder__add_element_btn placeholder-shimmer"></div>
                  <div className="hvnly--builder---api_property__singleProperty__builder__features placeholder">
                    <h2 className="placeholder-shimmer"></h2>
                    <div className="hvnly--builder---api_property__singleProperty__builder__features_list placeholder">
                      {[...Array(6)].map((_, index) => (
                        <div key={index} className="hvnly--builder---api_property__singleProperty__builder__feature_item placeholder-shimmer"></div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Sidebar Placeholder */}
        <div className="hvnly--builder---api_property__singleProperty__builder__sidebar placeholder">
          
          {/* Agent Info Card Placeholder */}
          <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card placeholder">
            <div className="hvnly--builder---api_property__singleProperty__builder__editable_area placeholder">
              <span className="hvnly--builder---api_property__singleProperty__builder__area_label placeholder-shimmer"></span>
              <div className="hvnly--builder---api_property__singleProperty__builder__add_element_btn placeholder-shimmer"></div>
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_header placeholder-shimmer"></div>
              <div className="hvnly--builder---api_property__singleProperty__builder__agent_form_modern placeholder-shimmer"></div>
            </div>
          </div>

          {/* Amenities Card Placeholder */}
          <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card placeholder">
            <div className="hvnly--builder---api_property__singleProperty__builder__editable_area placeholder">
              <span className="hvnly--builder---api_property__singleProperty__builder__area_label placeholder-shimmer"></span>
              <div className="hvnly--builder---api_property__singleProperty__builder__add_element_btn placeholder-shimmer"></div>
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_header placeholder-shimmer"></div>
              <div className="hvnly--builder---api_property__singleProperty__builder__amenities_list placeholder">
                {[...Array(5)].map((_, index) => (
                  <div key={index} className="hvnly--builder---api_property__singleProperty__builder__amenities_item placeholder-shimmer"></div>
                ))}
              </div>
            </div>
          </div>
          
          {/* Featured Card Placeholder */}
          <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card placeholder">
            <div className="hvnly--builder---api_property__singleProperty__builder__editable_area placeholder">
              <span className="hvnly--builder---api_property__singleProperty__builder__area_label placeholder-shimmer"></span>
              <div className="hvnly--builder---api_property__singleProperty__builder__add_element_btn placeholder-shimmer"></div>
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_header placeholder-shimmer"></div>
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_content placeholder-shimmer"></div>
            </div>
          </div>
          
          {/* Views Card Placeholder */}
          <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card placeholder">
            <div className="hvnly--builder---api_property__singleProperty__builder__editable_area placeholder">
              <span className="hvnly--builder---api_property__singleProperty__builder__area_label placeholder-shimmer"></span>
              <div className="hvnly--builder---api_property__singleProperty__builder__add_element_btn placeholder-shimmer"></div>
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_header placeholder-shimmer"></div>
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stats placeholder">
                {[...Array(7)].map((_, index) => (
                  <div key={index} className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat placeholder-shimmer"></div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaceholderLoader;